import api from './axiosConfig';

export const galleryAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/gallery', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/gallery/${id}`);
    return response.data;
  },
  
  upload: async (formData) => {
    const response = await api.post('/gallery', formData);
    return response.data;
  },
  
  update: async (id, formData) => {
    const response = await api.put(`/gallery/${id}`, formData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/gallery/${id}`);
    return response.data;
  },
};
